// hooks
import { useQuery } from 'react-query';
import { getFlexMatchEmployees } from 'RestAPIs/flex-match';

const useGetFlexMatchEmployees = (
  { requestId, filters },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['flexMatchEmployees', requestId, filters],
    async () => {
      const { data } = await getFlexMatchEmployees({ requestId, filters });
      return data;
    },
    { ...options }
  );
};

export default useGetFlexMatchEmployees;
